import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({
  children,
  roles,
  subRoles
}) {
  const { user } = useAuth();

  // Ainda carregando os dados do usuário
  if (user === null) {
    return (
      <div className="p-10 text-center text-muted-foreground">
        Carregando...
      </div>
    );
  }

  // Usuário não autenticado
  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  // Se não houver restrição de role ou subrole,
  // qualquer usuário autenticado pode acessar
  if (!roles && !subRoles) {
    return children;
  }

  // Admin continua tendo acesso total
  if (user.role === "admin") {
    return children;
  }

  // Verifica se a role principal está permitida
  const roleAllowed =
    roles?.includes(user.role);

  // Verifica se a subrole está permitida
  const subRoleAllowed =
    user.role === "operador" &&
    subRoles?.includes(user.sub_role);

  // Se nenhuma das duas permissões bater,
  // volta para a home
  if (!roleAllowed && !subRoleAllowed) {
    return <Navigate to="/" replace />;
  }

  return children;
}